import { Result } from "antd";
import { Button, NavBar, Space } from "antd-mobile";
import { useNavigate, useSearchParams } from "react-router";

export default function () {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return (
    <Space direction={"vertical"} style={{ width: "100%" }} gap={64} >
      <NavBar style={{ background: "white" }} onBack={() => navigate(searchParams.get("return") || "..",{replace: true})}>
        Esito
      </NavBar>
      <Result
        status="success"
        style={{ background: "white" }}
        title="Registrato con successo"
        description="La registrazione è stata completata con successo"
      />
      <Button block={true} type={"submit"} onClick={() => navigate("/mobile")}>
        Torna alla home
      </Button>
    </Space>
  );
}
